import { render, staticRenderFns } from "./PanelViewShow.vue?vue&type=template&id=0b7f8d9a"
import script from "./PanelViewShow.vue?vue&type=script&lang=js"
export * from "./PanelViewShow.vue?vue&type=script&lang=js"
import style0 from "./PanelViewShow.vue?vue&type=style&index=0&id=0b7f8d9a&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\ideaWorkSpace\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b7f8d9a')) {
      api.createRecord('0b7f8d9a', component.options)
    } else {
      api.reload('0b7f8d9a', component.options)
    }
    module.hot.accept("./PanelViewShow.vue?vue&type=template&id=0b7f8d9a", function () {
      api.rerender('0b7f8d9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/panel/list/PanelViewShow.vue"
export default component.exports